import React, { useCallback, useState, useEffect } from 'react'
import { VStack } from '@musinsa/mwms-ds'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { TabType, B2CUrlParams, B2BUrlParams } from '@/services/outbound/outboundWaitingStatus/types'
import { PageLayout } from '@/components/layout/PageLayout'
import { useMenuOnSession } from '@/components/layout/MainMenuOnSessionProvider'
import { Tabs } from '@/components/content/Tabs'
import { MenuStorage } from '@/utils/storage/MenuStorage'
import { Utils } from '@/utils/Utils'
import B2CContentWrapper from './components/B2CContentWrapper'
import B2BContentWrapper from './components/B2BContentWrapper'
import { useGetCutOffWarehouses } from '@/services/warehouse/useWareHouseQueries'

function OutboundWaitingStatus() {
  const { reload } = useMenuOnSession()
  const { parsedQs, replaceQuery } = useParsedQuery<B2CUrlParams | B2BUrlParams>()

  const currentTabType = (parsedQs.tabType as TabType) || 'B2C'

  const { data: cutOffWarehouses } = useGetCutOffWarehouses()

  const filteredWarehouses = cutOffWarehouses?.map((warehouse) => warehouse.warehouseCode)

  // 페이지 초기 로드 시 저장된 탭 상태 복원
  useEffect(() => {
    // URL에 tabType이 없고, 저장된 상태가 있다면 복원
    if (!parsedQs.tabType) {
      const savedTabSearch = MenuStorage.menuOnSession.getTabSearch(currentTabType)
      if (savedTabSearch) {
        const savedQuery = { ...Utils.qsParse(savedTabSearch), tabType: currentTabType }
        replaceQuery(savedQuery)
      }
    }
  }, []) // 최초 한번만 실행

  const handleTabChange = useCallback(
    (tabType: TabType) => {
      // 새로운 탭의 상태를 MenuOnSession에서 불러오기 (저장하지 않고 불러오기만)
      const savedTabSearch = MenuStorage.menuOnSession.getTabSearch(tabType)
      const newQuery = savedTabSearch ? { ...Utils.qsParse(savedTabSearch), tabType } : { tabType }

      replaceQuery(newQuery)
    },
    [replaceQuery],
  )

  return (
    <PageLayout gap={16}>
      <VStack gap={12}>
        <Tabs value={currentTabType} onTabChange={handleTabChange}>
          <Tabs.Item label="B2C 출고대기" value="B2C" />
          <Tabs.Item label="B2B 출고대기" value="B2B" />
        </Tabs>
      </VStack>

      {/* 탭별 컨텐츠 렌더링 */}
      {currentTabType === 'B2C' && (
        <B2CContentWrapper
          parsedQs={parsedQs as B2CUrlParams}
          replaceQuery={replaceQuery}
          reload={reload}
          currentTabType={currentTabType}
          filteredWarehouses={filteredWarehouses}
        />
      )}
      {currentTabType === 'B2B' && (
        <B2BContentWrapper
          parsedQs={parsedQs as B2BUrlParams}
          replaceQuery={replaceQuery}
          reload={reload}
          currentTabType={currentTabType}
          filteredWarehouses={filteredWarehouses}
        />
      )}
    </PageLayout>
  )
}

export default OutboundWaitingStatus
